import { BaseComponent } from "./base-component";

export class BprogressCircleComponent extends BaseComponent {}



// WEBPACK FOOTER //
// ./src/app/shared/extends-components/bprogress-circle-component.ts